import { contactSvcApi } from '@ctct/infrastructure-layer';

import { ContactsSchema } from './schemas';
import { zodService } from '../ZodService';

class ContactsRepo {
  public async getContactsCount() {
    const response = await contactSvcApi.getContactsCount();

    const data = zodService.safeParse(ContactsSchema, response.data);

    return data;
  }
}

export const contactsRepo = new ContactsRepo();
